/**
 * WelcomeMessage - Minimalist mission control styled welcome
 *
 * Features:
 * - Clean, compact layout
 * - Retro mission control aesthetic
 * - Key capabilities without clutter
 */

function WelcomeMessage() {
  return (
    <div className="mb-6">
      {/* Description */}
      <p className="text-sm text-retro-muted mb-4 leading-relaxed">
        AI assistant for conjunction analysis and collision avoidance, utilizing live orbital
        data. Ask questions in natural language to analyze CDMs, visualize trajectories, and
        plan maneuvers &mdash; with full transparency in the right-hand panel.
      </p>

      {/* Capabilities - compact list */}
      <div className="grid grid-cols-2 gap-x-6 gap-y-1 text-xs font-mono">
        <div className="flex items-center gap-2">
          <span style={{ color: '#ff8c42' }}>▸</span>
          <span className="text-retro-muted">Conjunction Analysis</span>
        </div>
        <div className="flex items-center gap-2">
          <span style={{ color: '#ff8c42' }}>▸</span>
          <span className="text-retro-muted">Trajectory Visualization</span>
        </div>
        <div className="flex items-center gap-2">
          <span style={{ color: '#ff8c42' }}>▸</span>
          <span className="text-retro-muted">Maneuver Planning</span>
        </div>
        <div className="flex items-center gap-2">
          <span style={{ color: '#ff8c42' }}>▸</span>
          <span className="text-retro-muted">Real-Time Data</span>
        </div>
      </div>
    </div>
  )
}

export default WelcomeMessage
